import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppContextProvider } from "components/Context/AppContext";
import { AuthProvider } from "components/Context/AuthContext";
import WebsitehomePage from "pages/TailRiskGlobal";
import NotFound from "pages/NotFound";
import PortfoliosPage from "pages/Portfolios";
import Login from "pages/Login";
import CreateAccount from "pages/CreateAccount";
import Summary from "pages/Summary";
import HoldingsPage from "pages/Holdings";
import RiskPage from "pages/Risk";
import StressScenarios from "pages/StressScenarios";
import ResetPassword from "pages/ResetPassword";
import LoginRequired from "components/Context/LoginRequired";
import PortfolioUpload from "pages/PortfolioUpload";
import ForgetPassword from "pages/ForgetPassword";
import UserApproval from "pages/UserApproval";
import ResetPasswordAfterLogin from "pages/ResetPasswordAfterLogin";
import UpdateEntitlement from "pages/UpdateEntitlement";
import Admin from "pages/Admin";
import PBIReport from "pages/PBIReport";
import PageUploadSecurity from "pages/UploadSecurity";
import Upload from "pages/Upload";
import Scheduler from "pages/Scheduler";
import WhatIfAnalysis from "pages/WhatIfAnalysis";
import Transactions from "pages/Transactions";
import Analytics from "pages/Analytics";
import SettingsPage from "pages/Settings";
import HistoricalPage from "pages/Historical";
import MasterDashboard from "pages/MasterDashboard";
import AlternativesPage from "pages/Alternatives";
import SecurityLevelPage from "pages/SecurityLevel";



function App() {


  return (
    <AuthProvider>
      <AppContextProvider>
        <Router>    
          <div className="content">
              <Routes>
                <Route exact path="/"         element={<WebsitehomePage />} />
                <Route path="/home"           element={<WebsitehomePage />} />
                <Route path="/login"          element={<Login           />} />
                <Route path="/createAccount"  element={<CreateAccount   />} />
                <Route path="/PBIReport"      element={<PBIReport       />} />

                <Route path="/dashboard"            element={<LoginRequired> <MasterDashboard /> </LoginRequired>} />
                <Route path="/summary"              element={<LoginRequired> <Summary />       </LoginRequired>} />
                <Route path="/holdings" element={<LoginRequired> <HoldingsPage /> </LoginRequired>} />
                <Route path="/risk"      element={<LoginRequired> <RiskPage />        </LoginRequired>} />
                <Route path="/stress"   element={<LoginRequired> <StressScenarios /> </LoginRequired>} />
                <Route path="/upload"           element={<LoginRequired> <Upload /> </LoginRequired>} />
                <Route path="/portfolioUpload"  element={<LoginRequired> <PortfolioUpload /> </LoginRequired> } />
                <Route path="/portfolios"       element={<LoginRequired> <PortfoliosPage /> </LoginRequired>} />

                <Route path="/resetPassword/:token"     element={<ResetPassword             />} />
                <Route path="/resetPasswordafterlogin"  element={<ResetPasswordAfterLogin   />} />
                <Route path="/forgetPassword"        element={<ForgetPassword    /> } />
                
                <Route path="/userApproval"          element={<LoginRequired> <UserApproval      /> </LoginRequired> } />
                <Route path="/updateEntitlement"     element={<LoginRequired> <UpdateEntitlement /> </LoginRequired> } />
                <Route path="/admin"                 element={<LoginRequired> <Admin             /> </LoginRequired> } />
                <Route path="/pageUploadSecurity"    element={<LoginRequired> <PageUploadSecurity /> </LoginRequired> } />
                <Route path="/scheduler"             element={<LoginRequired> <Scheduler /> </LoginRequired>} />
                <Route path="/whatif"               element={<LoginRequired> <WhatIfAnalysis /> </LoginRequired>} />
                <Route path="/transactions"        element={<LoginRequired> <Transactions />   </LoginRequired>} />
                <Route path="/analytics"           element={<LoginRequired> <Analytics />      </LoginRequired>} />
                <Route path="/settings"            element={<LoginRequired> <SettingsPage />   </LoginRequired>} />
                <Route path="/historical"          element={<LoginRequired> <HistoricalPage />   </LoginRequired>} />
                <Route path="/alternatives"       element={<LoginRequired> <AlternativesPage /> </LoginRequired>} />
                <Route path="/security-level"    element={<LoginRequired> <SecurityLevelPage /> </LoginRequired>} />


                <Route path="*"               element={<NotFound        />} />


              </Routes>
            </div>

        </Router>
      </AppContextProvider>
    </AuthProvider>
  );
}

export default App;
